import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

import { Observable } from 'rxjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import {
    ScriptLoaderService
} from './../../../../../_services';
import { Unit, Investor, Property, TypeUnit } from './../../../../../_models';
import {
    DropImageListModalComponent
} from '../../../../../shared/drop-image-list-modal';
import {
    ActionButtonComponent
} from '../../../../../shared/action-button';
import {
    LiveSearchSelectComponent
} from '../../../../../shared/live-search-select';

@Component({
    selector: 'app-unit-form',
    templateUrl: './unit-form.component.html',
    styleUrls: ['./unit-form.component.scss']
})
export class UnitFormComponent {
    form: FormGroup;
    parkingPlaceHolder: string = 'Teclee cajon';
    warehousePlaceHolder: string = 'Teclee bodega';
    limit: number = 2700000;
    formHeader = {
        icon: 'fa fa-user',
        text: 'UNIDAD'
    }
    unitId: number;
    disable = false;
    requests$: Observable<Object>;
    dataFetched: boolean = false;
    propertyTexts = {
        label: "Nombre de la propiedad",
        notFound: "Propiedad no encontrada",
        loading: "Cargando propiedades...",
        none: "Ninguna propiedad"
    }
    investorTexts = {
        label: "Propietario",
        notFound: "Propietario no encontrado",
        loading: "Cargando propietarios...",
        none: "Ningun propietario"
    }
    typeTexts = {
        label: "Tipo",
        notFound: "Tipo no encontrado",
        loading: "Cargando tipos de unidades...",
        none: "Ningun tipo"
    }
    @BlockUI('loading-form') loadingForm: NgBlockUI;

    @ViewChild(DropImageListModalComponent) imageList: DropImageListModalComponent;
    @ViewChild(ActionButtonComponent) save: ActionButtonComponent;
    @ViewChild('propertySelect') propertySelect: LiveSearchSelectComponent;
    @ViewChild('investorSelect') investorSelect: LiveSearchSelectComponent;
    @ViewChild('typeSelect') typeSelect: LiveSearchSelectComponent;

    keepIndicator = false;
    unit: any = this.unitData.make({});
    typeData: any;
    validation_messages = {
        'property': [
            { type: 'required', message: 'Campo requerido.' },
        ],
        'investor': [
            { type: 'required', message: 'Campo requerido.' },
        ],
        'id_orange': [
            { type: 'required', message: 'Campo requerido.' },
        ],
        'floor': [
            { type: 'required', message: 'Campo requerido.' }
        ],
        'in_pool': [
            { type: 'required', message: 'Campo requerido.' },
        ],
        'area_interior': [
            { type: 'required', message: 'Campo requerido.' },
        ],
        'area_common': [
            { type: 'required', message: 'Campo requerido.' },
        ],
        'area_terrace': [
            { type: 'required', message: 'Campo requerido.' },
        ]
    };
    // Constructor begin
    constructor(
        protected _fb: FormBuilder,
        protected _script: ScriptLoaderService,
        protected _location: Location,
        protected _route: ActivatedRoute,
        protected _router: Router,
        protected _domSanitizer: DomSanitizer,
        protected unitData: Unit,
        protected investorData: Investor,
        protected propertyData: Property,
        protected typeUnitData: TypeUnit
    ) {
        this.form = _fb.group({
            'in_pool': [0, Validators.compose([Validators.required])],
            'id_orange': ['', Validators.compose([Validators.required])],
            'floor': [1, Validators.compose([Validators.required])],
            'area_interior':
            [0, Validators.compose([Validators.required])],
            'motto_value':
            [0, Validators.compose([Validators.required])],
            'area_common':
            [0, Validators.compose([Validators.required])],
            'area_terrace':
            [0, Validators.compose([Validators.required])],
            'parking_spaces': [],
            'warehouses': [],
            'property_id':
            [null, Validators.compose([Validators.required])],
            'type_id':
            [null, Validators.compose([Validators.required])],
            'investor_id':
            [null, Validators.compose([Validators.required])],
            'investor': {},
            'property': {},
            'type': {},
            'furnished': [0, Validators.compose([Validators.required])]
        });
        this.unitData.sanitizer = _domSanitizer;
        this.unitData.makeWithSummary(this.form.value).subscribe(unit => {
            this.unit = unit;
        });
    }
    // Constructor end

    propertyChange(property) {
        this.selectProperty(property);
    }
    investorChange(investor) {
        this.selectInvestor(investor);
    }
    typeUnitChange(type) {
        this.selectType(type);
    }

    data(value) { }
    error(data) { console.error(data); }
    end() { }

    private back() {
        this._location.back();
    }
    private selectProperty(property: any) {
        this.form.controls['property_id'].setValue(property.id);
        this.form.controls['property'].setValue(property);
    }
    private selectInvestor(investor: any) {
        this.form.controls['investor_id'].setValue(investor.id);
        this.form.controls['investor'].setValue(investor);
    }
    private selectType(type: any) {
        this.form.controls['type_id'].setValue(type.type_id);
        this.form.controls['type'].setValue(type);
    }

    protected getFilesForm() {
        let form = new FormData();
        if (this.imageList.filesToDelete.length) {
            form.set('filesToDelete', this.imageList.filesToDelete.map(file => file.id).join(','));
        }
        this.imageList.filesToUpload.forEach(data => {
            form.append('filesToUpload[]', data);
        });
        return form;
    }
    protected getFormData(formValue) {
        let formData = this.getFilesForm();
        let value = null;
        Object.keys(formValue).forEach(key => {
            if (key == 'in_pool' || key == 'furnished')
                value = (formValue[key]) ? '1' : '0';
            else
                value = formValue[key];

            if (value != null) formData.set(key, value);
        });
        return formData;
    }
    protected triggerFormChange(form) {
        form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }

    protected change(files) {
        this.triggerFormChange(this.form);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/unit-form/unit-form.component.ts